// extracted by mini-css-extract-plugin
module.exports = {"readMoreText":"MerchandiseDeliveryAddressFieldStyles_readMoreText__36O-D","textWrapper":"MerchandiseDeliveryAddressFieldStyles_textWrapper__HLmsT"};